import Http from "@/libraries/Http";

export default {
    apiVersion: "v1",
    RESTroute: "project-budgets",

    async POST_executeImport(cache_key, data = {}) {
        return Http.post(
            `/${this.apiVersion}/${this.RESTroute}/execute-import/${cache_key}`,
            data
        );
    },

    async UPLOAD_file(formData) {
        console.log("UPLOAD_file called");
        return Http.post(
            `/${this.apiVersion}/${this.RESTroute}/import-from-csv`,
            formData,
            {
                headers: { "Content-Type": "multipart/form-data" }
            }
        );
    },

    async GET_report(project_id, params = {}) {
        return Http.get(
            `/${this.apiVersion}/${this.RESTroute}/report/${project_id}`,
            {
                params: params
            }
        );
    },

    async GET_detailedReport(project_id, params = {}) {
        return Http.get(
            `/${this.apiVersion}/${this.RESTroute}/detailed-report/${project_id}`,
            {
                params: params
            }
        );
    },

    /**
     * Get all resources
     * GET /resource
     */
    async GET(params = {}) {
        return Http.get(`/${this.apiVersion}/${this.RESTroute}`, {
            params: params
        });
    },

    /**
     * Get single resource
     * GET /resource/<id>
     */
    async GETS(id, params = {}) {
        return Http.get(`/${this.apiVersion}/${this.RESTroute}/${id}`, {
            params: params
        });
    },

    /**
     * Create resource
     * POST /resource
     * Payload: {}
     */
    async POST(data) {
        return Http.post(`/${this.apiVersion}/${this.RESTroute}`, data);
    },

    /**
     * Put resource
     * PUT /resource/<id>
     * Payload: {}
     */
    async PUT(data) {
        return Http.put(
            `/${this.apiVersion}/${this.RESTroute}/${data.id}`,
            data
        );
    },

    /**
     * Delete resource
     * DELETE /resource/<id>
     */
    async DELETE(id) {
        return Http.delete(`/${this.apiVersion}/${this.RESTroute}/${id}`);
    }
};
